import { Box } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
export const ClickBarrier = styled(Box) `
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100%;
  z-index: 1;
  opacity: 0;
`;
//# sourceMappingURL=ClickBarrier.js.map